import { connect } from 'react-redux'
import GoogleStorageInputs from './GoogleStorageInputs.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    accessKey: state.analyticsExport.exportApiConfig.googleStorage.accessKey,
    secretAccessKey: state.analyticsExport.exportApiConfig.googleStorage.secretAccessKey,
    region: state.analyticsExport.exportApiConfig.googleStorage.region,
    endpoint: state.analyticsExport.exportApiConfig.googleStorage.endpoint,
    bucketName: state.analyticsExport.exportApiConfig.googleStorage.bucketName,
    isFetching: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig,
    isSaving: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateExportApiConfig: key => e => dispatch(Actions.updateExportApiGoogleConfig(key, e.target.value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoogleStorageInputs)
